import React, { useRef, useEffect } from "react";
import "@/App.css";
import { ReactLenis, useLenis } from "lenis/react";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Manifesto from "@/components/Manifesto";
import Projects from "@/components/Projects";
import MarqueeSection from "@/components/MarqueeSection";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function ExposeLenis() {
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) window.__lenis = lenis;
  }, [lenis]);
  return null;
}

function App() {
  const lenisRef = useRef(null);

  return (
    <ReactLenis ref={lenisRef} root options={{ lerp: 0.08, smoothWheel: true }}>
      <ExposeLenis />
      <div className="App" data-testid="app-root">
        <div className="grain-overlay" aria-hidden="true" />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              borderRadius: 0,
              border: "1px solid #E5E5DF",
              background: "#FFFFFF",
              color: "#0A0A0A",
              fontFamily: "'IBM Plex Mono', monospace",
              fontSize: "0.8rem",
            },
          }}
        />
        <Nav />
        <main>
          <Hero />
          <Manifesto />
          <Projects />
          <MarqueeSection />
          <Contact />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}

export default App;
